<template>
  <router-link class="conversation-list-item d-flex align-center" :to="itemUrl">

    <div class="text flex-grow-1">
      <div class="farm flex-shrink-0" :class="{ unread: !isSelf && !isRead }">{{ conversation[getAccType].name }}</div>
      <div class="text flex-grow-1" :class="{ unread: !isSelf && !isRead }">{{ lastMessageBody }}</div>
    </div>
    <div class="date flex-shrink-0 d-flex align-center justify-end">
      {{ $d(conversation.last_message.created_at, 'shortDateTime') }}
      <ChevronIcon class="ml-2" size="24" />
    </div>
  </router-link>
</template>

<script>
import ChevronIcon from "@/components/icons/ChevronIcon.vue";

export default {
  components: {
    ChevronIcon
  },

  props: {
    conversationId: {
      type: Number,
      required: true
    },
    accType: {
      type: String,
      default: ""
    }
  },

  computed: {
    itemUrl() {
      return `/${this.accType.toLowerCase()}/conversations/${this.conversation.id}`;
    },
    isSelf() {
      return this.conversation.last_message.sender_type === this.accType;
    },
    isRead() {
      return this.conversation.last_message.status === "read";
    },
    getAccType() {
      return this.accType === "Farm" ? "shop" : "farm";
    },
    conversation() {
      return this.$store.state.conversations.list[this.conversationId];
    },
    lastMessageBody() {
      return this.$store.getters["conversations/lastMessageBody"](this.conversationId);
    }
  }
};
</script>

<style lang="scss" scoped>
.conversation-list-item {
  height: 60px;
  border: #ccc 1px solid;
  background-color: #fff;

  &:not(:first-child) {
    border-top: none;
  }
}

.farm {
  width: 400px;
  padding: 0 16px;
  color: #333;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  &.unread {
    font-weight: bold;

    &::before {
      content: "";
      display: inline-block;
      vertical-align: middle;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #DB3838;
      margin-right: 6px;
    }
  }
}

.text {
  color: #666;
  font-size: 14px;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 16px;

  &.unread {
    font-weight: bold;
  }
}

.date {
  color: #777;
  width: 120px;
  padding: 0 4px 0 16px;
  font-size: 12px;
  font-weight: normal;
  text-align: right;
  fill: currentColor;
}
</style>
